import { apiClient } from '../client'
import type { ApiResponse } from '../client.types'
import type { UserStatsRead, LeaderboardEntry, PrizePoolRead } from '../types'

/**
 * Statistics API endpoints
 * GET /stats/me - Get user stats
 * GET /stats/leaderboard - Get leaderboard
 * GET /stats/prize-pool - Get prize pool
 */

export const statsApi = {
  /**
   * Get user statistics (requires auth)
   * GET /stats/me
   */
  getUserStats(): Promise<ApiResponse<UserStatsRead>> {
    return apiClient.get<UserStatsRead>('/stats/me')
  },

  /**
   * Get leaderboard (public endpoint)
   * GET /stats/leaderboard
   */
  getLeaderboard(): Promise<ApiResponse<LeaderboardEntry[]>> {
    return apiClient.get<LeaderboardEntry[]>('/stats/leaderboard')
  },

  /**
   * Get prize pool (public endpoint)
   * GET /stats/prize-pool
   */
  getPrizePool(): Promise<ApiResponse<PrizePoolRead>> {
    return apiClient.get<PrizePoolRead>('/stats/prize-pool')
  },
}
